export const getCookies = Object.fromEntries(
  document.cookie.split("; ").map((cookie) => cookie.split("=")),
);

export const setCookie = (key: string, value: string) => {
  document.cookie = `${key}=${value}; path=/;`;
};
